import {
  ReplaceLostStolenCardInput,
  ReplaceLostStolenCardResult,
} from '@varo/graphql-schema-types';
import ReplaceLostStolenCard from 'services/graphql/mutations/ReplaceLostStolenCard';
import { getUuid } from 'shared/utils/getUuid/getUuid';
import {
  AnyVariables,
  CombinedError,
  OperationResult,
  useMutation,
} from 'urql';

interface UseReplaceCardResult {
  fetching: boolean;
  replaceLostStolenCard?: ReplaceLostStolenCardResult | null;
  error?: CombinedError;
  handleReplaceCard: (
    input: ReplaceLostStolenCardInput,
  ) => Promise<
    OperationResult<
      { replaceLostStolenCard: ReplaceLostStolenCardResult },
      AnyVariables
    >
  >;
}

const useReplaceCard = (): UseReplaceCardResult => {
  const [{ fetching, data, error }, executeReplaceCardMutation] = useMutation<{
    replaceLostStolenCard: ReplaceLostStolenCardResult;
  }>(ReplaceLostStolenCard);

  const handleReplaceCard = async (input: ReplaceLostStolenCardInput) =>
    await executeReplaceCardMutation({
      idempotencyId: getUuid(),
      input,
    });

  return {
    fetching,
    replaceLostStolenCard: data?.replaceLostStolenCard,
    error,
    handleReplaceCard,
  };
};

export default useReplaceCard;
